import { useUserSession } from "./use-user-session";

/**
 * Shared hook for fetching current user's roles and locations.
 * Backed by the shared `useUserSession` query so that this hook,
 * `useCurrentUserId`, and `useProjectId` all share a single batched fetch.
 */
export function useUserRole() {
  const query = useUserSession();
  const data = query.data;

  return {
    userId: data?.userId ?? null,
    ...query,
    // Convenience accessors
    isAdmin: data?.isAdmin ?? false,
    isMasterAdmin: data?.isMasterAdmin ?? false,
    isCenterManager: data?.isCenterManager ?? false,
    isStatePartner: data?.isStatePartner ?? false,
    isGrowthPartner: data?.isGrowthPartner ?? false,
    userRole: data?.role ?? null,
    roles: data?.roles ?? [],
    locationIds: data?.locationIds ?? [],
    locations: data?.locations ?? [],
    userState: data?.userState ?? null,
  };
}
